module.exports = __webpack_public_path__ + "static/media/lalashan_mobile.d80a183d.webp";